import { routerNamePrefix } from './router'
import { FEEDBACK_MODIFIABLE } from './const'

export default {
  beforeCreate() {
    const { feedback } = this.$store.state.trainConfirm
    if (!feedback) {
      // 用户直接进入结果页（比如复制结果页链接）
      this.$router.push({
        name: `${routerNamePrefix}_main`,
        query: this.$route.query,
      })
    }
  },
  computed: {
    reselectable() {
      const { feedback } = this.$store.state.trainConfirm
      return feedback && feedback.status === FEEDBACK_MODIFIABLE
    },
  },
  methods: {
    chooseAgain() {
      this.frogReport(`/click/gardenTrainingResult/reselect`)
      this.goMain()
    },
    goMain() {
      this.$router.push({
        path: `/trainConfirm/main`,
        query: { from: 'result', ...this.$route.query },
      })
    },
    frogReport(url, extra = []) {
      this.$addFrog(1531, url, [
        { key: 'submitresumeid', value: this.$route.query.srId },
        ...extra,
      ])
    },
  },
}
